export const scWalletSynthetixPerpV2AdvancedOrder = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'requestPrice', type: 'uint256' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				indexed: false,
				internalType: 'struct SynthetixLimitOrders.PairOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'AddPairOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: true, internalType: 'contract Authority', name: 'newAuthority', type: 'address' }
		],
		name: 'AuthorityUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' }
		],
		name: 'CancelFullOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'bool', name: 'isFirst', type: 'bool' }
		],
		name: 'CancelIndividualOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' }
		],
		name: 'CancelPairOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'executionPrice', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'totalFee', type: 'uint256' }
		],
		name: 'ExecuteLimitOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'executionPrice', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'totalFee', type: 'uint256' }
		],
		name: 'ExecutePairOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' }],
		name: 'Initialized',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }
		],
		name: 'OwnershipTransferred',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'requestPrice', type: 'uint256' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceA', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceB', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				indexed: false,
				internalType: 'struct SynthetixLimitOrders.FullOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'SubmitFullOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'user', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'requestPrice', type: 'uint256' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				indexed: false,
				internalType: 'struct SynthetixLimitOrders.PairOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'SubmitPairOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'address', name: 'oldReceipient', type: 'address' },
			{ indexed: false, internalType: 'address', name: 'newReceipient', type: 'address' }
		],
		name: 'UpdateFeeReceipient',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'uint256', name: 'oldFlat', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'newFlat', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'oldPercentage', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'newPercentage', type: 'uint256' }
		],
		name: 'UpdateFees',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'uint256', name: 'oldCutoff', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'newCutoff', type: 'uint256' }
		],
		name: 'UpdatePythDeltaCutoff',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'market', type: 'address' },
			{ indexed: false, internalType: 'bytes32', name: 'oldId', type: 'bytes32' },
			{ indexed: false, internalType: 'bytes32', name: 'newId', type: 'bytes32' }
		],
		name: 'UpdatePythId',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'uint256', name: 'oldCutoff', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'newCutoff', type: 'uint256' }
		],
		name: 'UpdatePythTimeCutoff',
		type: 'event'
	},
	{
		inputs: [
			{ internalType: 'uint256', name: 'id', type: 'uint256' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				internalType: 'struct SynthetixLimitOrders.PairOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'addPairOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'authority',
		outputs: [{ internalType: 'contract Authority', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'orderId', type: 'uint256' }],
		name: 'cancelFullOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ internalType: 'bool', name: 'isFirst', type: 'bool' }
		],
		name: 'cancelIndividualOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'orderId', type: 'uint256' }],
		name: 'cancelPairOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'orderId', type: 'uint256' }],
		name: 'executeLimitOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'uint256[]', name: 'limitOrders', type: 'uint256[]' },
			{ internalType: 'uint256[]', name: 'pairOrders', type: 'uint256[]' }
		],
		name: 'executeMultiple',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'orderId', type: 'uint256' }],
		name: 'executePairOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'feeReceipient',
		outputs: [{ internalType: 'address', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'flatFee',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'id', type: 'uint256' }],
		name: 'getFullOrder',
		outputs: [
			{
				components: [
					{ internalType: 'bool', name: 'isStarted', type: 'bool' },
					{ internalType: 'bool', name: 'isCompleted', type: 'bool' },
					{ internalType: 'bool', name: 'isCancelled', type: 'bool' },
					{ internalType: 'address', name: 'user', type: 'address' },
					{ internalType: 'address', name: 'market', type: 'address' },
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'requestPrice', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceA', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceB', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				internalType: 'struct SynthetixLimitOrders.FullOrder',
				name: 'order',
				type: 'tuple'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'contract IPyth', name: '_pyth', type: 'address' },
			{ internalType: 'address', name: '_owner', type: 'address' },
			{ internalType: 'address', name: '_feeReceipient', type: 'address' },
			{ internalType: 'uint256', name: '_flatFee', type: 'uint256' },
			{ internalType: 'uint256', name: '_percentageFee', type: 'uint256' }
		],
		name: 'initialize',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'nextFullOrderId',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'owner',
		outputs: [{ internalType: 'address', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'percentageFee',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'pyth',
		outputs: [{ internalType: 'contract IPyth', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'address', name: '', type: 'address' }],
		name: 'pythIds',
		outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'pythPriceDeltaCutoff',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'pythPriceTimeCutoff',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'contract Authority', name: 'newAuthority', type: 'address' }],
		name: 'setAuthority',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceA', type: 'uint256' },
					{ internalType: 'uint256', name: 'priceB', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				internalType: 'struct SynthetixLimitOrders.FullOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'submitFullOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{
				components: [
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'firstPairB', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairA', type: 'uint256' },
					{ internalType: 'uint256', name: 'secondPairB', type: 'uint256' }
				],
				internalType: 'struct SynthetixLimitOrders.PairOrderRequest',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'submitPairOrder',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
		name: 'transferOwnership',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'address', name: '_feeReceipient', type: 'address' }],
		name: 'updateFeeReceipient',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'uint256', name: '_flatFee', type: 'uint256' },
			{ internalType: 'uint256', name: '_percentageFee', type: 'uint256' }
		],
		name: 'updateFees',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'newCutoff', type: 'uint256' }],
		name: 'updatePythDeltaCutoff',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{ internalType: 'bytes32', name: 'id', type: 'bytes32' }
		],
		name: 'updatePythOracleId',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address[]', name: 'markets', type: 'address[]' },
			{ internalType: 'bytes32[]', name: 'ids', type: 'bytes32[]' }
		],
		name: 'updatePythOracleIds',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [{ internalType: 'uint256', name: 'newCutoff', type: 'uint256' }],
		name: 'updatePythTimeCutoff',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	}
];
